var _mask, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3055_2696",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 9.41177,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 9.41177,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3055_2696)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.70605,
    y: 9.4118,
    width: 30.5882,
    height: 25.8824,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchived);
export default __webpack_public_path__ + "static/media/archived.fb41f3b214fb16e69c5f7f1f848423b2.svg";
export { ForwardRef as ReactComponent };